



import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component({
  name: 'chart',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) chartOptions: any
  @Prop({ required: true }) series: any
  @Prop({ required: true }) type: string
}
